const zhCN = {
  appName: '智客园区管理系统',
  appShortName: 'SMART iACC',
  company: '成都鱼住未来科技有限公司',
  ICP: '蜀ICP备19014280号'
}
const enUS = {
  appName: 'Park Management System',
  appShortName: 'SMART iACC',
  company: 'Chengdu Yuzhu Future technology co., LTD',
  ICP: 'ICP no. 19014280'
}

export default { zhCN, enUS }
